import React from "react";
import {required, validatePhone, validateUsername, validateConfirmPassword, validatePassword} from "../../../validation/basicValidation";
import MaterialTextField from "../../comun/Forms/MaterialTextField";
import MenuItem from "@material-ui/core/MenuItem";
import SelectField from "../../comun/Forms/SelectField";
import Button from "@material-ui/core/Button";
import './RegisterUser.scss'
import {registerUser} from "../Users/UserAction";
import {connect} from "react-redux";
import {Field, withFormik} from "formik";
import * as Yup from "yup";
import Divider from "@material-ui/core/Divider";
import {closeDialogAction, openDialogAction} from "../../comun/DialogManager/DialogManagerAction";
import HasRole from "../../../auth/components/HasRole/HasRole";
import {Grid} from "../../comun/Grid/Grid";
import {cache} from "../../../util/utilCache";

const mapDispatchToProps = (dispatch, ownprops) => {
    const res = {
        onPostRegister: async data => {
            return await registerUser(data)(dispatch);
        },
        onAssign: data => {
            dispatch(openDialogAction(data));
        },
        onDialogClose: data => {
            dispatch(closeDialogAction({id: "edit-user-dialog"}))
        }
    };
    if (ownprops.dialogData) {
        if (ownprops.dialogData.dispatchAction) {
            res.onPostRegister = async data => {
                return await ownprops.dialogData.dispatchAction(data)(dispatch);
            }
        }
    }
    return res;
}


export let RegisterUser = ({onPostRegister, isSubmitting, form, dialogData, setFieldValue, isValid, values, ...props}) => {
    return (
        <div className="box ">
            <form onSubmit={props.handleSubmit}>
                <Grid columns={1} className="register-user-form-block">
                    <h1>Datos de Usuario</h1>
                    <Divider/>
                    <Field name="username" component={MaterialTextField} disabled="true"
                           label="Nombre de Usuario"/>
                    <HasRole role="AREA_COORDINATOR">
                        <Field name="rol"
                               label="Selecciona el Rol"
                               variant="outlined"
                               component={SelectField}>
                            <MenuItem value="COMMERCIAL_PROMOTER">Promotor Comercial</MenuItem>
                            <MenuItem value="TEAM_LEADER">Jefe de Equipo</MenuItem>
                        </Field>
                    </HasRole>
                    <HasRole role="FL_MANAGER">
                        <Field name="rol"
                               variant="outlined"
                               label="Selecciona el Rol"
                               component={SelectField}
                               placeholder="Selecciona el Rol">
                            <MenuItem value="COMMERCIAL_PROMOTER">Promotor Comercial</MenuItem>
                            <MenuItem value="TEAM_LEADER">Jefe de Equipo</MenuItem>
                            <MenuItem value="AREA_COORDINATOR">Coordinador de zona</MenuItem>
                            <MenuItem value="FL_MANAGER">Responsable FL</MenuItem>                            
                        </Field>
                    </HasRole>
                    <HasRole role="ADMIN">
                        <Field name="rol"
                               variant="outlined"
                               label="Selecciona el Rol"
                               component={SelectField}
                               placeholder="Selecciona el Rol"

                        >
                            <MenuItem value="COMMERCIAL_PROMOTER">Promotor Comercial</MenuItem>
                            <MenuItem value="TEAM_LEADER">Jefe de Equipo</MenuItem>
                            <MenuItem value="AREA_COORDINATOR">Coordinador de zona</MenuItem>
                            <MenuItem value="FL_MANAGER">Responsable FL</MenuItem>
                            <MenuItem value="ADMIN">Administrador</MenuItem>                            
                        </Field>
                    </HasRole>
                    <Field name="hours" component={MaterialTextField} 
                           label="Horas diarias de Trabajo"/>
                    <h1>Datos Personales y Profesionales</h1>
                    <Divider/>
                    <Field name="name" component={MaterialTextField} type="text" disabled="true"
                           label="Nombre y Apellidos"/>
                    <div>
                        {/*{(values.rol === 'COMMERCIAL_PROMOTER' || values.rol === 'TEAM_LEADER') ? }*/}
                        <Field name="code" component={MaterialTextField} type="text"
                               label="Código Identificativo"/>
                    </div>
                    <div>
                        <Field name="m4" component={MaterialTextField} type="text"
                               label="Código M4"/>
                    </div>
                    <div>
                        <Field name="phone" component={MaterialTextField} type="text"
                               label="Teléfono"/>
                    </div>
                    <div>
                        <Field name="email" component={MaterialTextField} type="text" disabled="true"
                               label="Email"/>
                    </div>
                    <div>
                        <Field name="dni" component={MaterialTextField} type="text"
                               label="DNI"/>
                    </div>
                    <div>
                        <Field name="size"
                               label="Talla"
                               component={SelectField}
                               placeholder="Selecciona una Talla"
                               errorText="Escoge una talla">
                            <MenuItem value="XS">XS</MenuItem>
                            <MenuItem value="S">S</MenuItem>
                            <MenuItem value="M">M</MenuItem>
                            <MenuItem value="L">L</MenuItem>
                            <MenuItem value="XL">XL</MenuItem>
                            <MenuItem value="XXL">XXL</MenuItem>
                        </Field>
                    </div>
                </Grid>
                <Button className="register-user-button" size="medium" disabled={isSubmitting || !isValid}
                        variant="contained" color="secondary" type="submit">Guardar</Button>
            </form>
        </div>
    )
}

RegisterUser = withFormik(
    {
        mapPropsToValues: (props) => {
            if (props.dialogData) {
                if (props.dialogData.user) {
                    const data = props.dialogData.user;
                    return {
                        username: data.username,
                        name: data.name,
                        password: '',
                        confirmPassword: '',
                        hours: data.hours,
                        id: data.id,
                        phone: data.phone,
                        email: data.email,
                        code: data.code,
                        m4: data.m4,
                        size: data.size,
                        dni: data.dni,
                        rol: props.dialogData.user.authorities[0].authority
                    }
                }
            }
            return {
                username: '', password: '', confirmPassword: '', hours: '',name: '', m4: '', phone: '', email: '',
                code: '', size: 'M', rol: 'COMMERCIAL_PROMOTER', id: null, dni: ''
            }
        },
        validateOnChange: false,
        handleSubmit: async (values, {props, setSubmitting, resetForm}) => {
            try {
                props.onPostRegister(values).then(() => {
                    if (props.dialogData) {
                        props.onDialogClose();
                        props.dialogData.user = values;
                    }
                    resetForm();
                });
            } catch (e) {

            }
        },
        validationSchema: (props) => {
            const schema = {
                hours: Yup.string().required('Obligatorio'),
                name: Yup.string().required('Obligatorio'),
                code: Yup.string(),
                m4: Yup.string(),
                phone: Yup.string().test('is-phone', "No es un número de teléfono válido", value => validatePhone(value)),
                size: Yup.string().required('Obligatorio'),
                rol: Yup.string().required('Obligatorio')
            };
            return Yup.object().shape(schema)
        },
        displayName: 'Registrar Usuario',
    }
)(RegisterUser);
RegisterUser = connect(null, mapDispatchToProps)(RegisterUser)
